import {
  Security,
  Book,
  Bookmark,
  Help,
  Home,
  Forward,
  Person,
  QuestionAnswer,
  HowToReg,
} from '@material-ui/icons'
import {
  CLICK_AUTHOR_GENRE_MENU_EVENT,
  CLICK_COLLECTIONS_MENU_EVENT,
  CLICK_HELP_ACCOUNT_MENU_EVENT,
  CLICK_HOME_MENU_EVENT,
  CLICK_LEARNING_RESOURCES_MENU_EVENT,
  CLICK_SAVED_GUIDES_MENU_EVENT,
  CLICK_SUBSCRIPTION_ACCOUNT_MENU_EVENT,
  CLICK_SUGGEST_TITLE_MENU_EVENT,
  MODAL_OPENED_EVENT,
  SUGGEST_A_TITLE,
  CLICK_MOBILE_APP_MENU_EVENT,
  CLICK_FREEMIUM_UPGRADE_CTA,
} from 'amplitude/events'
import useLogEvent from 'amplitude/useLogEvent'
import { useSignOutHandler } from 'auth/handleSignOut'
import UserType from 'utils/UserType'
import useLogSuggestTitle from 'bookSuggestions/useLogSuggestTitle'
import { toggleDialog, logModalOpened } from 'utils/dialog/utils'
import { useLocation } from '@reach/router'
import FreeBadge from 'ui/FreeBadge'
import { useIsFreemium } from 'utils/useUserType'
import MobileAppIcon from './mobileAppIcon/SidebarItemMobileApp'
import UpgradeYourPlanMenuItem from './UpgradeYourPlanMenuItem'

const adminOrOperator = userType =>
  userType === 'admin' || userType === 'operator'

export default (userType, userCategory, suggestTitleDialogRef) => {
  const handleSignOut = useSignOutHandler()
  const logEvent = useLogEvent()
  const logSuggestTitle = useLogSuggestTitle({ action: MODAL_OPENED_EVENT })
  const isFreemium = useIsFreemium()

  const useLogUpgradeCTA = () => {
    const { pathname } = useLocation()
    return () =>
      logEvent(CLICK_FREEMIUM_UPGRADE_CTA, {
        page_slug: pathname,
        destination: 'checkout',
        url: pathname,
        location: 'sidebar',
        cta_id: 'sidebar',
        button_label: 'Upgrade Your Plan',
      })
  }

  const logUpgradeCTA = useLogUpgradeCTA()

  const log = event => () => logEvent(event)

  const logOut = e => {
    e.preventDefault()
    handleSignOut()
  }

  const toggleSuggestTitle = e => {
    e.preventDefault()
    log(CLICK_SUGGEST_TITLE_MENU_EVENT)()
    logSuggestTitle()
    toggleDialog(
      suggestTitleDialogRef,
      logModalOpened(logEvent, SUGGEST_A_TITLE, suggestTitleDialogRef),
    )()
  }

  const cmsOptions = adminOrOperator(userType)
    ? [{ icon: Security, name: 'CMS', path: '/admin' }, { divider: true }]
    : []

  const isStudent = userCategory === UserType.STUDENT.value
  const isParent = userCategory === UserType.PARENT.value

  const navigationLinks = [
    ...cmsOptions,
    {
      collapsedIcon: FreeBadge,
      fullWidthItem: UpgradeYourPlanMenuItem,
      path: '/checkout/annual?upgrade=true',
      onClick: logUpgradeCTA,
      hidden: !isFreemium,
    },
    {
      name: 'My SuperSummary',
      icon: Home,
      exactPath: '/',
      activePaths: ['/subscriber/home/'],
      onClick: log(CLICK_HOME_MENU_EVENT),
      external: true,
    },
    {
      name: 'Collections',
      icon: Book,
      path: '/collections/',
      onClick: log(CLICK_COLLECTIONS_MENU_EVENT),
      external: true,
    },
    {
      name: 'Saved Guides',
      icon: Bookmark,
      path: '/saved-guides/',
      onClick: log(CLICK_SAVED_GUIDES_MENU_EVENT),
      external: true,
    },
    isStudent || isParent
      ? {
          name: 'Learning Resources',
          icon: HowToReg,
          path: '/resources/#homework-and-learning-resources',
          activePaths: ['/resources/'],
          onClick: log(CLICK_LEARNING_RESOURCES_MENU_EVENT),
        }
      : {
          name: 'Author & Genre',
          icon: HowToReg,
          path: '/resources/#author-and-genre-resources',
          activePaths: ['/resources/'],
          onClick: log(CLICK_AUTHOR_GENRE_MENU_EVENT),
        },
    {
      name: 'Suggest a Title',
      icon: QuestionAnswer,
      onClick: toggleSuggestTitle,
    },
    {
      name: 'Mobile App',
      icon: MobileAppIcon,
      path: '/download',
      target: '_blank',
      onClick: log(CLICK_MOBILE_APP_MENU_EVENT),
      external: true,
    },
    { divider: true },
    {
      name: 'Account',
      icon: Person,
      path: '/subscription/',
      onClick: log(CLICK_SUBSCRIPTION_ACCOUNT_MENU_EVENT),
    },
    {
      name: 'Help',
      icon: Help,
      path: process.env.REACT_APP_HELPCENTER_HOME,
      onClick: log(CLICK_HELP_ACCOUNT_MENU_EVENT),
      target: '_blank',
      external: true,
    },
    { name: 'Logout', icon: Forward, onClick: logOut },
  ]

  return navigationLinks.filter(item => !item.hidden)
}
